import { useQuery } from '@tanstack/react-query';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import { TOwnProducts } from '../company/types';

export const getCompanyLogo = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/files/companyLogo`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCompanyConfigOld = async (dispatch: Dispatch, name: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/configuration/${name}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCompanyConfig = (dispatch: Dispatch, name: string) =>
  useQuery({
    queryKey: ['companyConfig', name],
    queryFn: async (): Promise<
      string | number | boolean | null | undefined
    > => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/company/configuration/${name}`,
        dispatch,
      });
      if (response) return response.data;
    },
    retry: 1,
    enabled: !!name,
  });

export const getCompanyMultipleConfig = async (
  dispatch: Dispatch,
  names: string[],
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/configuration/${names.join(',')}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getOwnEnrollmentStatus = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/ownEnrollmentStatus`,
    dispatch,
  });
  if (response) return response.data;
};

export const triggerScrapOwnBusiness = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/company/triggerScrapOwnBusiness`,
    dispatch,
  });
  if (response) return response.data;
};

export const getContacts = async (dispatch: Dispatch, query: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/businessesWithContacts?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getOwnCompanyProducts = (dispatch: Dispatch) =>
  useQuery({
    queryKey: ['company', 'products'],
    queryFn: async (): Promise<TOwnProducts | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: `internal/product`,
        dispatch,
      });
      if (response) return response.data?.items;
    },
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
